/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IHistoryModalController extends IBaseModalControllerScope {
        historyItems: Wars.Domain.Model.Dtos.HistoryDto[];
        getValue: any;
        processConfigId: string;
        codeGroupId: string;
        process: Wars.Domain.Model.Dtos.ProcessDto;
    }

    export class HistoryModalController extends BaseModalController {
        scope: IHistoryModalController;

        constructor(
            $scope: IHistoryModalController,
            process: Wars.Domain.Model.Dtos.ProcessDto,
            processConfigId: string,
            formDataId: string,
            propertyId: string,
            codeGroupId: string,
            rowId: string,
            uniqueId: string,
            private historyService: services.HistoryService,
            private variableTypeService: services.VariableTypeService,
            private processDocumentService: services.ProcessDocumentService,
            close: any)
        {
            super($scope, close);
            this.scope = $scope;
            this.scope.getValue = (i) => this.getValue(i);
            this.scope.processConfigId = processConfigId;
            this.scope.codeGroupId = codeGroupId;
            this.scope.process = process;

            if (formDataId) {
                if (propertyId && rowId) {
                    this.historyService.getListFormFieldHistory(process.id, formDataId, uniqueId, rowId, propertyId).then(items => {
                        $scope.historyItems = items;
                    });
                } else {
                    this.historyService.getFormFieldHistory(process.id, formDataId, uniqueId).then(items => {
                        $scope.historyItems = items;
                        //add missing history documents to process documents list 
                        this.addMissingDocumentsToProcessDto();
                    });
                }
            } else {
                if (propertyId && rowId) {
                    this.historyService.getListProcessDataHistory(process.id, uniqueId, rowId, propertyId).then(items => {
                        $scope.historyItems = items;
                    });
                } else {
                    this.historyService.getProcessDataHistory(process.id, uniqueId).then(items => {
                        $scope.historyItems = items;
                        //add missing history documents to process documents list 
                        this.addMissingDocumentsToProcessDto();
                    });
                }
            }
        }

        private addMissingDocumentsToProcessDto() {
            if (this.scope.historyItems != null && this.scope.historyItems.length > 0) {
                for (var i = 0; i < this.scope.historyItems.length; i++) {
                    if (this.scope.process && this.scope.process.documents) {
                        if (!this.scope.historyItems[i].document) continue;
                        var match = Enumerable.from(this.scope.process.documents).singleOrDefault(x => x.id === this.scope.historyItems[i].document.id);
                        if (!match) {
                            this.scope.process.documents.push(this.scope.historyItems[i].document);
                            if (this.scope.historyItems[i].document.isSecured) {
                                this.scope.process.canDownloadSecureDocument[this.scope.historyItems[i].document.id] = this.scope.historyItems[i].canDownloadDocument;
                            }
                        }
                    }
                }
            }
        }

        private getValue(item: Wars.Domain.Model.Dtos.HistoryDto): any {
            if (item.variableType === Wars.Domain.Model.Codes.Enums.VariableType.Document) {
                //return this.processDocumentService.getDocumentById(this.scope.process, item.value);
                return item.document;
            } else {
                let returnValue = this.variableTypeService.format(item.value, item.variableType);
                return returnValue;     
            } 
        }
    }
}

warsApp.registerController('HistoryModalController',
    [
        '$scope', 'process', "processConfigId", 'formDataId', 'propertyId', "codeGroupId",
        'rowId', 'uniqueId', 'historyService', 'variableTypeService', "processDocumentService", 'close']);